import { Button, Checkbox, Col, Form, Input, Modal, Row } from "antd";
import TextArea from "antd/es/input/TextArea";
import React from "react";
import AttachmentsUpload from "../AttachmentsUpload";
import MultiSelect from "../MultiSelect";
import { addRecipients, cc } from "./data";

function Email({ setIsModalOpen, isModalOpen, emailTo }) {
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <Modal
      title="Send Email"
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={null}
    >
      <Form layout="vertical">
        <Row gutter={[0, 8]}>
          <Col span={24}>
            <Form.Item label="From" required>
              <Input disabled defaultValue="this.getinstance@gmail.com" />
            </Form.Item>
            <Form.Item>
              <Checkbox>Send from donotreply@appfolio.com</Checkbox>
            </Form.Item>
          </Col>
          {emailTo === "unit" ? (
            <Col span={24}>
              <Form.Item required>
                <div className="labelForPay">
                  <label htmlFor="tenants" required>
                    Include
                  </label>
                  <a href="/people/vendors/new">Copy Email Address</a>
                </div>
                <h4>Tenants</h4>
                <Checkbox>
                  <p>seerat ali:</p>
                  <p>seeratshah@gmail.com</p>
                </Checkbox>
              </Form.Item>
            </Col>
          ) : null}
          {emailTo !== "unit" ? (
            <Col span={24}>
              <Form.Item required>
                <div className="labelForPay">
                  <label htmlFor="recipients" required>
                    Recipients
                  </label>
                  <a href="/people/vendors/new">Copy Email Address</a>
                </div>
                <TextArea rows={2} defaultValue="William" disabled />
                <p className="silver-text">
                  A separate email will be sent to each recipient for privacy
                </p>
              </Form.Item>
            </Col>
          ) : null}
          <Col span={24}>
            <Form.Item label="Cc">
              <MultiSelect options={cc} placeholder="Type to search" />
            </Form.Item>
          </Col>
          {emailTo === "owner" || emailTo === "unit" ? (
            <Col span={24}>
              <Form.Item label="Bcc">
                <MultiSelect options={cc} placeholder="Type to search" />
              </Form.Item>
            </Col>
          ) : null}
          {emailTo === "property" ? (
            <Col span={24}>
              <Form.Item label="Additional Recipients">
                <MultiSelect
                  options={addRecipients}
                  placeholder="Type to search"
                />
              </Form.Item>
            </Col>
          ) : null}
          <Col span={24}>
            <Form.Item label="Subject" required>
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Message" required>
              <TextArea rows={8} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Row gutter={[4, 0]}>
              <Col>
                <Button type="primary" onClick={() => handleOk()}>
                  Send
                </Button>
              </Col>
              <Col>
                <Button onClick={() => handleCancel()}>Cancel</Button>
              </Col>
              <Col>
                <Button type="link">Customize My Signature</Button>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            {/* <AttachmentsUpload /> */}
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default Email;
